export default __webpack_public_path__ + "static/casalino-8eba5ae650fec42c45acc27b8174b26a.jpg";